import Dimm from '@components/pass/interview/common/dimm';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useCustomQuestionList } from '@repository/interviewPractices/pooledQuestions/usePooledQuestions';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import classnames from 'classnames/bind';
import InterviewPracticeQuestionList from '../../common/questionList';
import InterviewPracticeQuestionSelectBodyMyselfEmpty from './empty';
import InterviewPracticeQuestionSelectMyselfInput from './input';
import style from './myself.module.scss';

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectBodyMyself = () => {
  const { data: userInfo } = useUserInfo();
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const { data: myselfQuestionList, refetch } = useCustomQuestionList({
    enabled: isAuthorityUser,
  });
  const myselfQuestionCount = myselfQuestionList?.questions.length;

  const renderQuestionList = () => {
    if (myselfQuestionCount === 0) {
      return <InterviewPracticeQuestionSelectBodyMyselfEmpty />;
    }
    return (
      <InterviewPracticeQuestionList
        className={cx('questionList')}
        questionList={myselfQuestionList?.questions ?? []}
      />
    );
  };

  const refetchQuestionList = () => {
    refetch();
  };

  if (!isAuthorityUser) return <Dimm style={{ width: 1200, height: 614 }} />;

  return (
    <div className={cx('myselfWrap')}>
      <div className={cx('title')}>
        내가 만든 질문<span className={cx('highlightText')}>{myselfQuestionCount}</span>개
      </div>
      <InterviewPracticeQuestionSelectMyselfInput refetchQuestionList={refetchQuestionList} />
      {renderQuestionList()}
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodyMyself;
